
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls,apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const getDevicesUaApi = createApi({
    reducerPath: 'devicesUnauth',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
    }),
    endpoints: (builder) => ({
        getDevicesUnauthByName: builder.query({
            query: (payload) => ({
                url: apiUrls?.itpNsaDevicesUrl_ua,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useGetDevicesUnauthByNameQuery } = getDevicesUaApi;